module.exports = __webpack_public_path__ + "img/0.4e7acf6a.png";